import React from 'react';
import useUser from '../store/selectors/useUser';
import useActiveBrand from '../store/selectors/useActiveBrand';
import useApiPost from './useApiPost';

const buildFormData = (id, user, bId) => {
  let formData = new FormData();
  formData.set('hID', 'deleteVideo');
  formData.set('uID', user.id);
  formData.set('bID', bId);
  formData.set('vID', id);
  return formData;
};

export const useDeleteVideo = () => {
  const { handlePost } = useApiPost();
  const user = useUser();
  const bId = useActiveBrand();
  const deleteVideo = React.useCallback(
    ({ id, ...other }) => {
      handlePost({ data: buildFormData(id, user, bId), ...other });
    },
    [bId, user, handlePost]
  );

  return { deleteVideo };
};
